import type { ConsoleLogMethod } from './ConsoleLogMethod.js';

/** Statuses for completed tasks (successful or not) */
export type TaskReporterCompleteTaskStatus = 'complete' | 'fail' | 'abort' | 'skip';
/** Statuses for incomplete tasks */
export type TaskReporterIncompleteTaskStatus = 'pending' | 'running';

/** All task statuses */
export type TaskReporterTaskStatus = TaskReporterCompleteTaskStatus | TaskReporterIncompleteTaskStatus;

/** All types of log messages */
export type LogMessageType = TaskReporterTaskStatus | ConsoleLogMethod;
